import axios from "axios";
import url from "../../helpers/url";

const HandleSubmitOrder = async ({
  email,
  name,
  lastname,
  phone,
  address1,
  address2,
  stripeTokenId,
  paymentMethod,
  total,
  Note,
  user,
  City,
  ZIP,
  cart,
  delivery,
}) => {
  let response = await axios
    .post(
      `${url}/orders`,
      {
        email,
        name,
        lastname,
        phone,
        address1,
        address2,
        stripeTokenId,
        paymentMethod,
        total,
        Note,
        City,
        ZIP,
        cart,
        delivery,
      },
      {
        headers: {
          Authorization: `Bearer ${user.token}`,
        },
      }
    )
    .catch((error) => {
      console.clear();
    });
  return response;
};

export { HandleSubmitOrder as default };
